import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";
import { Device } from "@pepdirect/v3/styles/screenSizes";

export const StyledRDD = styled.div`
  font-size: 13px;
  line-height: 1.25;
  margin-bottom: 40px;
`;

export const StyledAlertText = styled.div`
  &,
  a {
    color: ${colors.blue};
  }

  a {
    font-weight: 500;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;

  svg {
    flex-shrink: 0;
  }
`;

export const StyledDeliveryDate = styled.div<{ show: boolean }>`
  ${({ show }) => !show && `display: none;`}
`;

export const StyledChangeDateText = styled.a`
  text-decoration: underline;
  cursor: pointer;
  color: ${({ theme }) => theme.color.primary};
`;

export const StyledCalendar = styled.div`
  @media ${Device.mobile} {
    height: 100vh;
    overflow: scroll;
  }
`;

export const StyledMsgWrapper = styled.div`
  margin-top: 16px;
  padding: 16px 24px 12px;
  font-size: 24px;
  font-weight: 700;

  @media ${Device.mobile} {
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.05);
    margin: 0 0 20px;
    padding: 16px 8px 16px 12px;
  }
`;

export const StyledMsgSubtitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-top: 8px;
  color: ${colors.gray500};
`;

export const StyledDatePicker = styled.div<{ show: boolean }>`
  ${({ show }) =>
    show
      ? `
    visibility: visible;
  `
      : `
    visibility: hidden;
    width: 0;
  `};

  .react-datepicker {
    border: none;
    box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.1);

    @media ${Device.mobile} {
      width: 360px;
      padding-bottom: 32px;
    }

    &__input-container {
      outline-color: ${colors.gray300};

      input {
        padding: 8px 16px;
        font-size: 16px;
        border-radius: 2px;
        border: 1px solid ${colors.gray300};
        width: 120px;
      }
    }

    &__triangle {
      z-index: 100;
      background: none;

      &::before {
        top: 0;
        border-bottom-color: ${colors.gray300} !important;
      }

      &::after {
        border-bottom-color: ${colors.white} !important;
      }
    }

    &__header {
      background: none;
      border-bottom: none;
    }

    &__day-name {
      font-size: 16px;
      font-weight: 700;
    }

    &__day--selected {
      background-color: ${colors.blueForm};
      border-radius: 50%;
    }

    &__day,
    &__day-name {
      width: 32px;
      line-height: 32px;

      @media ${Device.mobile} {
        width: 43px;
        line-height: 43px;
      }
    }

    &__day {
      &:hover,
      &:active,
      &:focus {
        border-radius: 50%;
      }

      &:hover:focus {
        color: ${colors.white};
      }
    }

    &__current-month {
      font-size: 18px;
      margin-bottom: 4px;
    }

    &__month-container {
      margin: 0 20px 40px;

      @media ${Device.mobile} {
        clear: both;
        margin: 0;
      }
    }
  }
`;
